(function() {
    var po = document.createElement('script');
    po.type = 'text/javascript';
    po.async = true;
    po.src = 'https://apis.google.com/js/platform.js?onload=googleOnLoad';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(po, s);
})();

function googleOnLoad(){
    gapi.load('auth2', function () {
        gapi.auth2.init();
    });
}


function googleSignOut() {
    var auth2 = gapi.auth2.getAuthInstance();
    auth2.signOut().then(function (response) {

    });
    return false;
}

function googleSignIn() {
    var $this = $(this);
    var auth2 = gapi.auth2.getAuthInstance();
    console.log(auth2);
    auth2.signIn().then(function (response) {

        var profile = auth2.currentUser.get().getBasicProfile();
        $.ajax(siteurl + 'google-login.php', {
            method: 'POST',
            data: {
                uid: profile.getId(),
                name: profile.getName(),
                imageUrl: profile.getImageUrl(),
                email: profile.getEmail(),
                token: response.getAuthResponse().id_token,
                source: $this.data('source') || 'no-source'
            }
        }).done(function () {
           window.location.reload();
        });

    });
    return false;
}

function disconnect() {
    var auth2 = gapi.auth2.getAuthInstance();
    auth2.disconnect();
}

$(document).on('click', '[data-login="google"]', googleSignIn);